export default __webpack_public_path__ + "static/media/shop.8398f034.png";